<template>
  <div class="opc-succezz-layout" role="main">
    <!-- Desktop: two-column zm-row/zm-col -->
    <div v-if="is_desktop_reactive" class="opc-succezz-layout__top">
      <div class="opc-succezz-layout__top__inner">
        <zm-row>
          <zm-col :span="8">
            <div class="opc-succezz-layout__top-left">
              <slot />
              <div class="opc-succezz-layout__bottom">
                <div class="opc-succezz-layout__bottom__inner">
                  <slot name="promotes" />
                </div>
              </div>
            </div>
          </zm-col>
          <zm-col :span="4">
            <div class="opc-succezz-layout__top-right">
              <slot name="details" />
              <slot name="feedback" />
            </div>
          </zm-col>
        </zm-row>
      </div>
    </div>
    <!-- Mobile/tablet: stacked -->
    <template v-else>
      <div class="opc-succezz-layout__top__inner">
        <slot />
      </div>
      <div class="opc-succezz-layout__order-details">
        <slot name="details" />
      </div>
      <div class="opc-succezz-layout__bottom">
        <div class="opc-succezz-layout__bottom__inner">
          <slot name="promotes" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ViewLayoutResponsive',
  mounted() {
    document.body.classList.add('opc-succezz__body');
  },
};
</script>

<style lang="scss">
@import "./style/header.scss";
</style>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/_variables.scss';

.opc-succezz-layout {
  margin: 0 auto;
}

@include media(desktop) {
  .opc-succezz-layout {
    &__top {
      background: var(--zoom-color-bg-default, #FFFFFF);
      display: flex;
      justify-content: center;

      &__inner {
        max-width: 1500px;
        margin-top: 64px;
        margin-bottom: 64px;
        flex: 1;
        // 1025px: 24px sides → 1400px: 164px (smooth, same range as column gap)
        margin-left: max(24px, min(164px, calc(24px + 140px * (100vw - 64.0625rem) / 23.4375rem)));
        margin-right: max(24px, min(164px, calc(24px + 140px * (100vw - 64.0625rem) / 23.4375rem)));
      }
    }
    &__top-left {
      // 1025px: small gap (64px) → 1400px: larger gap (180px) as width increases
      padding-right: max(64px, min(180px, calc(64px + 116px * (100vw - 64.0625rem) / 23.4375rem)));
    }
    &__bottom__inner {
      margin: 0 auto;
    }
  }
}

@include media(mobile, tablet) {
  .opc-succezz-layout {
    padding: $mobile-space;

    &__top__inner {
      margin: 0 auto;
      padding: $mobile-space 0;
      background: var(--zoom-color-bg-default, #FFFFFF);
    }

    &__bottom__inner {
      margin: 0 auto;
    }
  }
}
</style>
